import { Card, Typography } from "antd";
import { DatabaseOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import "../Pages/CSS/DonnesBases.css";

import TypesPrestations from "./TypesPrestations";
import Specialites from "./Specialites";
import CreationActes from "./CreationActes";
import AffectationActe from "./AffectationActe";
import ArticlesAchat from "./ArticlesAchat";
import JournauxComptable from "./JournauxComptables";
import FournisseursDivers from "./FournisseursDivers";
import TypesBenefs from "./TypesBenefs";
import TypesDoc from "./TypesDoc";
//import React from 'react'
const { Title } = Typography;

const tabListNoTitle = [
  {
    key: "1",
    label: "Types de Prestations",
  },
  {
    key: "2",
    label: "Spécialités",
  },
  {
    key: "3",
    label: "Création Mdcts.&Actes",
  },
  {
    key: "4",
    label: "Affectations Actes",
  },
  {
    key: "5",
    label: "Articles Achats",
  },
  {
    key: "6",
    label: "Journaux Comptables",
  },
  {
    key: "7",
    label: "Fournisseurs Divers",
  },
  {
    key: "8",
    label: "Types Bénefs",
  },
  {
    key: "9",
    label: "Types Documents",
  },
];

const DonneesBases = () => {
  //  const [activeTabKey1, setActiveTabKey1] = useState('tab1');
  const [activeTabKey2, setActiveTabKey2] = useState("1");

  const onTab2Change = (key) => {
    setActiveTabKey2(key);
  };
  const getActiveTabLabel = () => {
    const activeTab = tabListNoTitle.find(tab => tab.key === activeTabKey2);
    return activeTab ? activeTab.label : '';
  };

  return (
    <div style={{ padding: 12 }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          padding: "10px 20px",
          background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
          borderRadius: 10,
          boxShadow: "0 4px 15px rgba(24, 144, 255, 0.3)",
          marginBottom: 16,
        }}
      >
        <DatabaseOutlined style={{ fontSize: 22, color: "#fff" }} />
        <span
          style={{
            fontSize: 18,
            fontWeight: 600,
            color: "#fff",
            letterSpacing: 0.5,
          }}
        >
          Données de Bases - {getActiveTabLabel()}
        </span>
      </div>
      <Card
        style={{
          borderRadius: 12,
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
          border: "1px solid #f0f0f0",
          overflow: "hidden",
        }}
        tabList={tabListNoTitle.map((tab) => ({
          ...tab,
          label: (
            <span
              style={{
                fontSize: 14,
                fontWeight: activeTabKey2 === tab.key ? 600 : 500,
                color: activeTabKey2 === tab.key ? "#1890ff" : "#595959",
                transition: "all 0.3s",
              }}
            >
              {tab.label}
            </span>
          ),
        }))}
        activeTabKey={activeTabKey2}
        onTabChange={onTab2Change}
        tabProps={{
          size: "large",
          tabBarStyle: {
            marginBottom: 0,
            paddingLeft: 16,
            paddingRight: 16,
            background: "#fafafa",
            borderBottom: "2px solid #f0f0f0",
          },
        }}
        bodyStyle={{
          padding: "20px",
          minHeight: 500,
          background: "#fff",
        }}
      >
        {activeTabKey2 === "1" && <TypesPrestations />}
        {activeTabKey2 === "2" && <Specialites />}
        {activeTabKey2 === "3" && <CreationActes />}
        {activeTabKey2 === "4" && <AffectationActe />}
        {activeTabKey2 === "5" && <ArticlesAchat />}
        {activeTabKey2 === "6" && <JournauxComptable />}
        {activeTabKey2 === "7" && <FournisseursDivers />}
        {activeTabKey2 === "8" && <TypesBenefs />}
        {activeTabKey2 === "9" && <TypesDoc />}

      </Card>
    </div>
  );
};

export default DonneesBases;
